import { useEffect, useState } from "react";

import {
    Badge,
    Button,
    Card,
    CardBody,
    Spinner,
    Table
} from "reactstrap";
import { CoordinatorJoinRequest } from "../../Private/types/PrivateChat";
import PrivateChatService from "../../Private/Services/PrivateChatService";
import { approveRequest, rejectRequest } from "../../Services/GroupJoinRequestService";
import "./CoordinatorJoinRequestList.css";


const CoordinatorJoinRequestList = () => {

    const [loading, setLoading] = useState(true);

    const [requests, setRequests] =
        useState<CoordinatorJoinRequest[]>([]);

    useEffect(() => {

        loadRequests();

    }, []);

    const loadRequests = async () => {

        try {

            setLoading(true);

            const result =
                await PrivateChatService.getCoordinatorRequests();

            setRequests(result);

        }
        finally {

            setLoading(false);

        }

    };

    const approve = async (
        requestId: string
    ) => {

        await approveRequest(requestId);

        loadRequests();

    };

    const reject = async (
        requestId: string
    ) => {

        const remarks =
            prompt("Reason for rejection");

        if (!remarks)
            return;

        await rejectRequest(
            requestId,
            remarks
        );

        loadRequests();

    };

    if (loading)
        return <Spinner />;

    return (

        <Card>

            <CardBody>

    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 className="mb-2 mb-md-0">
            Pending Join Requests
        </h5>

        <Badge color="warning" pill>
            {requests.length} Pending
        </Badge>
    </div>

    {/* Desktop Table */}

    <div className="desktop-request-table">

        <Table hover responsive bordered className="align-middle">

            <thead className="table-primary">

                <tr>

                    <th>Group</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Requested</th>
                    <th>Status</th>
                    <th >Actions</th>

                </tr>

            </thead>

            <tbody>

                {requests.map((request) => (

                    <tr key={request.groupJoinRequestId}>

                        <td>{request.groupName}</td>

                        <td>{request.userName}</td>

                        <td>{request.email}</td>

                        <td>
                            {new Date(request.requestedAt).toLocaleString()}
                        </td>

                        <td>
                            <Badge color="warning">
                                Pending
                            </Badge>
                        </td>

                        <td>

                            <Button
                                color="success"
                                size="sm"
                                className="me-2"
                                onClick={() => approve(request.groupJoinRequestId)}
                            >
                                Approve
                            </Button>

                            <Button
                                color="danger"
                                size="sm"
                                onClick={() => reject(request.groupJoinRequestId)}
                            >
                                Reject
                            </Button>

                        </td>

                    </tr>

                ))}

            </tbody>

        </Table>

    </div>

    {/* Mobile Cards */}

    <div className="mobile-request-cards">

        {requests.map((request) => (

            <Card
                key={request.groupJoinRequestId}
                className="request-card shadow-sm border-0 mb-3"
            >

                <CardBody>

                    <div className="d-flex justify-content-between align-items-center mb-3">

                        <h6 className="fw-bold text-primary mb-0">
                            {request.userName}
                        </h6>

                        <Badge color="warning">
                            Pending
                        </Badge>

                    </div>

                    <div className="request-row">
                        <span>Group</span>
                        <strong>{request.groupName}</strong>
                    </div>

                    <div className="request-row">
                        <span>Email</span>
                        <strong>{request.email}</strong>
                    </div>

                    <div className="request-row">
                        <span>Requested</span>
                        <strong>
                            {new Date(request.requestedAt).toLocaleString()}
                        </strong>
                    </div>

                    <div className="d-grid gap-2 mt-3">

                        <Button
                            color="success"
                            onClick={() => approve(request.groupJoinRequestId)}
                        >
                            ✓ Approve
                        </Button>

                        <Button
                            color="danger"
                            onClick={() => reject(request.groupJoinRequestId)}
                        >
                            ✕ Reject
                        </Button>

                    </div>

                </CardBody>

            </Card>

        ))}

    </div>

</CardBody>

        </Card>

    );

};

export default CoordinatorJoinRequestList;